import React, { useEffect } from 'react'
import { Header } from '.';
import { useStateContext } from '../contexts/ContextProvider';

window.Buffer = window.Buffer || require("buffer").Buffer;

const NavButton = ({ customFunc, icon, color, dotColor }) => (
  <button type="button" onClick={customFunc} style={{ color }}
    className="relative text-xl rounded-full p-3 hover:bg-light-gray">
    <span style={{ background: dotColor }}
      className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2" />
    {icon}
  </button>
)

const Navbar = () => {
  const { setActiveMenu, screenSize, setscreenSize, location } = useStateContext();

  const getKaseyaServer = () => {

    const jwt = localStorage.getItem('jwtToken');

    let base64Url = jwt.split('.')[1]; // token you get
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    let decodedData = JSON.parse(Buffer.from(base64, 'base64').toString('binary'));

    let kaseyaServerAddressClaim = decodedData['Bitdefender:RMM:KaseyaX:identity:claim:KaseyaServerAddress'];

    let serverPreffix = kaseyaServerAddressClaim.split('//')[1].split('.')[0];
    return serverPreffix
  }

  useEffect(() => {
    const handleResize = () => setscreenSize(window.innerWidth);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  return (
    <>
      <div className='ml-10 pb-1 h-[56px] flex justify-center' id='locationPath'>
        <span className='flex justify-center items-center'>{location}</span>
      </div>
      <div className='h-8 mr-4'>
        <Header />
      </div>
    </>
  )
}

export default Navbar